/** 对象存储文件下载:POST /files/presign-download 换短时签名 URL(需登录). */

import { http } from "./api";

export interface PresignDownloadResp {
  download_url: string;
  expires_at: string;
}

export function presignDownload(
  objectKey: string,
  downloadName?: string,
): Promise<PresignDownloadResp> {
  return http<PresignDownloadResp>("/files/presign-download", {
    method: "POST",
    body: { object_key: objectKey, download_name: downloadName },
  });
}
